module.exports = __webpack_public_path__ + "img/file.fbe2f000.svg";